<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('dateDevis.header')}}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="columns is-multiline">
      <div class="column is-6">
        <b-field :label="$t('dateDevis.date.dateDebut')">
          <b-datepicker show-week-number
                        v-model="dateDebut"
                        icon="calendar-today"
                        nearby-selectable-month-days
                        :editable="true"/>
        </b-field>
      </div>
      <div class="column is-6">
        <b-field :label="$t('dateDevis.date.dateFin')">
          <b-datepicker show-week-number
                        v-model="dateFin"
                        icon="calendar-today"
                        nearby-selectable-month-days
                        :editable="true"/>
        </b-field>
      </div>
    </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="saveDate()">
              {{ $t('general.button.apply') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'popUpChangeDateRegroupement',
  props: {
    ligneRegroupement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dateDebut: null,
      dateFin: null,
    };
  },
  methods: {
    saveDate() {
      this.ligneRegroupement.dateDebut = this.dateDebut;
      this.ligneRegroupement.dateFin = this.dateFin;
      this.$parent.close();
    },
  },
  mounted() {
    this.dateDebut = cloneDeep(
      this.ligneRegroupement.dateDebut ? new Date(this.ligneRegroupement.dateDebut) : null,
    );
    this.dateFin = cloneDeep(
      this.ligneRegroupement.dateFin ? new Date(this.ligneRegroupement.dateFin) : null,
    );
  },
};
</script>

<style scoped>

</style>
